module.exports = __webpack_public_path__ + "img/down.9121e80a.webp";